export enum TimesheetEntryStatus {
    Approved = 'Approved',
    Incomplete = 'Incomplete',
    ReviewRequired = 'Review Required'
}
